import React, { useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import PieChart from 'components/PieChart/PieChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'

/**
 * @name ByLocationType
 * @desc Render Card Type chart
 * @filterValues IReportsFilter
 */
const ByLocationType = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<{ name: string; value: number }[]>([])

    React.useEffect(() => {
        setLoading(true)
        ReportsApi.getByLocationType(filterValues).then((data) => {
            setLoading(false)

            const top5LocationTypes = data.filter(
                (locationtype: any) => locationtype.name !== 'Other Location'
            )

            setData(top5LocationTypes)
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    const byLocationTypeColorPalette =
        clientTheme.charts.pieCharts.defaultPieChart

    return (
        <AccentArea title="Domestic vs Offshore">
            <PieChart
                colorPalette={byLocationTypeColorPalette}
                data={data}
                loading={loading}
                testId="byLocationType"
            />
        </AccentArea>
    )
}

export default ByLocationType
